var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap bl_payment_pop",
      staticStyle: { width: "1000px", height: "550px" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          on: {
            click: function ($event) {
              return _vm.close()
            },
          },
        },
        [_vm._v("close")]
      ),
      _c("div", { staticClass: "popup_cont" }, [
        _c("h1", { staticClass: "page_title" }, [
          _vm._v("입금/계산서/BL발행요청"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content_box" },
          [
            _c("VirtualAccountFreightBillMethod", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShow.method,
                  expression: "isShow.method",
                },
              ],
              ref: "FBMethod",
              attrs: {
                "err-arr": _vm.errArr.method,
                "clear-arr": _vm.clearArr.method,
                "dp-id": _vm.freightBillInfo.dpId,
                "btn-type": _vm.freightBillInfo.btnType,
                "validation-method": _vm.validationMethod,
              },
            }),
            _c("VirtualAccountBLPaymentTarget", {
              ref: "BLPaymentTarget",
              attrs: {
                "bl-list": _vm.freightBillInfo.blList,
                "iss-yn": _vm.freightBillInfo.issYn,
                "apay-yn": _vm.freightBillInfo.apayYn,
              },
              on: {
                setReqBizCatCd: _vm.setReqBizCatCd,
                setTaxInvoice: _vm.setTaxInvoice,
              },
            }),
            _c("FreightBillDmdRadio", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShow.dmdRadio && _vm.reqBizCatCd !== "",
                  expression: "isShow.dmdRadio && reqBizCatCd !== ''",
                },
              ],
              ref: "FBDmdRadio",
              attrs: {
                "dmd-cat-cd": _vm.freightBillInfo.dmdCatCd,
                "ori-dmd-cat-cd": _vm.oriDmdCatCd,
                "req-biz-cat-cd": _vm.reqBizCatCd,
                "va-yn": "Y",
              },
              on: { child: _vm.getChildData },
            }),
            _c("FreightBillInfo", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShow.info,
                  expression: "isShow.info",
                },
              ],
              ref: "FBInfo",
              attrs: {
                "dp-id": _vm.freightBillInfo.dpId,
                "bl-list": _vm.freightBillInfo.blList,
                "va-yn": "Y",
              },
              on: { child: _vm.getChildData },
            }),
            _vm.reqBizCatCd !== "" && _vm.freightBillInfo.dmdCatCd === "C"
              ? _c("FreightBillCredit", {
                  ref: "FBCredit",
                  attrs: { "bl-list": _vm.freightBillInfo.blList },
                  on: { child: _vm.getChildData },
                })
              : _vm._e(),
            _c("FreightBillTax", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShow.taxTemplate,
                  expression: "isShow.taxTemplate",
                },
              ],
              ref: "FBTax",
              attrs: {
                "err-arr": _vm.errArr.taxTemplate,
                "clear-arr": _vm.clearArr.taxTemplate,
                "dp-id": _vm.freightBillInfo.dpId,
                "btn-type": _vm.freightBillInfo.btnType,
                "validation-tax-template": _vm.validationTaxTemplate,
                "bl-list": _vm.freightBillInfo.blList,
              },
              on: { setReqCont: _vm.setReqCont },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "mt10 text_center" }, [
          _c(
            "a",
            {
              staticClass: "button blue lg",
              attrs: { href: "javascript:void(0)", id: "invoicePopupCall" },
              on: {
                click: function ($event) {
                  return _vm.paymentChk()
                },
              },
            },
            [_vm._v("다음")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "button gray lg",
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("msg.ONIM099P010.003")))]
          ),
        ]),
      ]),
      _c(
        "div",
        [
          _c(
            "win-layer-pop",
            { staticClass: "inv_popup" },
            [
              _vm.popupComponent
                ? _c(_vm.popupComponent, {
                    tag: "component",
                    attrs: { "parent-info": _vm.popupParams },
                    on: {
                      close: _vm.closeInvPopup,
                      callback: _vm.callbackInvPopup,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }